import { NError, NSuccess } from '@src/configs/const.config'
import { checkAuth } from '@libs/localStorage'
import { TResApi, TResApiErr } from '@src/configs/interface.config'
import { TSendNotification, TSendNotificationResult } from '@src/modules'
import { notification } from 'antd'
import { useMutation } from 'react-query'

import { sendNotification } from '../apis/notification'

export const useSendNotification = () => {
  const accessToken = checkAuth()
  return useMutation(
    (body: TSendNotification) => sendNotification(body, accessToken),
    {
      onSuccess: (res: TResApi<TSendNotificationResult>) => {
        const reached = res?.data?.targetUsers ?? 0
        const tokens = res?.data?.tokensUsed ?? 0
        notification.success({
          message: NSuccess,
          description: `Đã gửi tới ${reached} đại lý (${tokens} thiết bị).`,
        })
      },
      onError: (error: TResApiErr) => {
        notification.error({ message: NError, description: error?.message })
      },
    },
  )
}
